import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from '../app-config.constants';
import { IAppConfig } from '../app-config.interface';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ObjectResponse } from '../classes/object-response';
import { HttpParams } from '@angular/common/http';
import { IBlogResponse } from '../classes/interfaces';
import { Observable, of, empty } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import { ErrorService, ErrorKey } from './error/error.service';
import { CacheService } from './cache.service';

@Injectable()
export class BlogService {
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
    private http: HttpClient,
    private apiConfig: ApiConfigService,
    private errorService: ErrorService,
    private cache: CacheService
  ) { }

  getByTags(tags: string[]): Observable<IBlogResponse[]> {

    const base = this.apiConfig.getServerRoot(this.appConfig.urls.blog.base);
    const route = this.appConfig.urls.blog.base;
    const params = new HttpParams()
      .set('tagNames', tags.join(','));

    const hashKey = this.cache.getRequestHash(route, params);
    const hashValue = this.cache.get<IBlogResponse[] | string>(hashKey, true);
    if (hashValue) {
      return of(typeof hashValue === 'string' ? JSON.parse(hashValue as string) : hashValue);
    }

    return this.http.get<ObjectResponse<IBlogResponse[]>>(base + route, { params: params, withCredentials: true })
      .pipe(
        tap(res => this.cache.set(hashKey, res.result, 300)),
        map(res => res.result),
        catchError((error: HttpErrorResponse) => {
          this.errorService.displayError(ErrorKey.cms, error.error.errorCode, 12);
          return empty();
        })
      );
  }

  /**
   * Get the required links to other pages that we need to put on pages from the blog for SEO purposes
   * @param page: 'ldp' | 'app' | 'opp'
   * @param province
   * @param city
   */
  getFooterLinksByProvinceAndCity(page: string, province: string, city: string): Observable<IBlogResponse[]> {
    // We strip out all non word characters and replace them with '' strings
    const regex =  /(\W)+/g;
    province = province.replace(regex, '');
    city = city.replace(regex, '');
    const tags = [`cms-${page}-footer-${province}`, `cms-${page}-footer-${city}`];
    return this.getByTags(tags);
  }

}


